import { render, staticRenderFns } from "./onlineLearning.vue?vue&type=template&id=3295874b&scoped=true&"
import script from "./onlineLearning.vue?vue&type=script&lang=js&"
export * from "./onlineLearning.vue?vue&type=script&lang=js&"
import style0 from "./onlineLearning.vue?vue&type=style&index=0&id=3295874b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295874b",
  null
  
)

export default component.exports